export default __webpack_public_path__ + "static/media/star-sq.96200632.png";